<template>
    <div v-if="content">
        <span v-html="paperStyle"></span>
        <section class="paper">
            <div class="header">
                <h1>ใบกำกับภาษี</h1>
                <div class="issue">
                    <div>วันที่ {{ $AppUtility.displayOnlyDate(content.data.closeDate) }}</div>
                </div>
            </div>

            <div class="document-data">
                <div class="left">
                    <div class="text-strong">ร้านค้าผู้ให้บริการ</div>
                    <div>{{ content.store.info.name }}</div>
                    <div>เลขประจำตัวผู้เสียภาษี {{ content.store.info.taxId }}</div>
                    <div>{{ [ content.store.info.address, content.store.info.subDistrict, content.store.info.district, content.store.info.province, content.store.info.postCode ].join(' ') }}</div>
                    <div>เบอร์โทร {{ content.store.info.tel }}</div>
                </div>
                <div class="right">
                    <div class="text-strong">รายละเอียดลูกค้า</div>
                    <div>{{ getCustomerName() }}</div>

                    <template v-if="content.data.jobType === $Constants.JOB_FORM_FLEET
                                || content.data.jobType === $Constants.JOB_FORM_STORE">
                        <div>{{ getAddress() }}</div>
                    </template>
                    
                    <div>เบอร์ติดต่อ {{ getTelData() }}</div>
                    <div v-if="customerTaxId">เลขประจำตัวผู้เสียภาษี {{ customerTaxId }}</div>

                    <template v-if="content.data.jobType !== $Constants.JOB_FORM_STORE">
                        <div>ข้อมูลรถ {{ getLicensePlateData() }}</div>
                        <div>{{ getCarData() }}</div>
                    </template>
                </div>
            </div>

            <div class="bill-no">เลขที่ {{ content.data.number }}</div>

            <table cellpadding="0" cellspacing="0">
                <tr>
                    <th class="text-center"></th>
                    <th width="50%">รายการสินค้า</th>
                    <th class="text-center">หน่วยละ</th>
                    <th class="text-center">จำนวน</th>
                    <th class="text-center">ราคา</th>
                </tr>
                <tr v-for="(item, index) in orderList" :key="index">
                    <td class="text-center" :style="getOrderColumnHeight(index)">{{ index + 1 }}</td>
                    <td>
                        {{ item.name }}
                        <span class="small" v-if="item.sku">SKU: {{ item.sku }}</span>
                        <span class="small" v-if="item.dot">สัปดาห์ยาง: {{ item.dot }}</span>
                    </td>
                    <td class="text-center">{{ appHelper.getCommaNumber(item.price.toFixed(2)) }}</td>
                    <td class="text-center">{{ item.quantity }}</td>
                    <td class="text-center">{{ appHelper.getCommaNumber((item.price * item.quantity).toFixed(2)) }}</td>
                </tr>
                <tr class="line space-top">
                    <td colspan="4" class="text-right">รวมเงิน</td>
                    <td class="text-center">{{ appHelper.getCommaNumber(totalPrice.toFixed(2)) }}</td>
                </tr>
                <tr>
                    <td colspan="4" class="text-right">ส่วนลดเทิร์นอะไหล่</td>
                    <td class="text-center">- {{ appHelper.getCommaNumber(turnPartPrice.toFixed(2)) }}</td>
                </tr>
                <tr>
                    <td colspan="4" class="text-right">ส่วนลดอื่นๆ</td>
                    <td class="text-center">- {{ appHelper.getCommaNumber(discountPrice.toFixed(2)) }}</td>
                </tr>
                <tr class="space-bottom" v-if="content.data.bill.includeTax">
                    <td colspan="4" class="text-right">ภาษีมูลค่าเพิ่ม</td>
                    <td class="text-center">{{ appHelper.getCommaNumber(taxPrice.toFixed(2)) }}</td>
                </tr>
                <tr class="line footer">
                    <td colspan="4" class="text-right">จำนวนเงินทั้งสิ้น</td>
                    <td class="text-center">{{ appHelper.getCommaNumber(finalPrice.toFixed(2)) }}</td>
                </tr>
            </table>

            <div class="bottom-data">
                <div class="payment-title text-strong">การชำระเงิน</div>
                
                <div class="checkbox-group">
                    <span class="checkbox"><span v-if="content.data.bill.paymentMethod === $Constants.PAYMENT_METHOD_CASH">x</span></span>
                    <label>เงินสด</label>
                </div>
                <div class="checkbox-group">
                    <span class="checkbox"><span v-if="content.data.bill.paymentMethod === $Constants.PAYMENT_METHOD_CREDIT_CARD">x</span></span>
                    <label>บัตรเครดิต</label>
                </div>
                <div class="checkbox-group">
                    <span class="checkbox"><span v-if="content.data.bill.paymentMethod === $Constants.PAYMENT_METHOD_TRANSFER">x</span></span>
                    <label>โอนเงิน</label>
                </div>
                <div class="checkbox-group">
                    <span class="checkbox"><span v-if="content.data.bill.paymentMethod === $Constants.PAYMENT_METHOD_CHEQUE">x</span></span>
                    <label>เช็ค</label>
                </div>
            </div>

            <div class="remark">
                <strong>หมายเหตุ</strong> {{ content.store.remark.receipt }}
            </div>

            <div class="signature">
                <div class="col space"></div>
                <div class="col license">
                    <div class="line"></div>
                    <div class="date">&nbsp;</div>
                    <label>ผู้ส่งสินค้า</label>
                </div>
                <div class="col space"></div>
                <div class="col license">
                    <div class="line"></div>
                    <div class="date">&nbsp;</div>
                    <label>ผู้รับสินค้า</label>
                </div>
                <div class="col space"></div>
            </div>
        </section>
    </div>
</template>

<script>
import Helper from '@/resources/Helper';
import OptionLicensePlateProvince from '@/database/staticOption/LicensePlateProvince';

export default {
    data() {
        return {
            content: null,
            paperStyle: '',
            localStyle: `
                .paper .bottom-data {
                    margin-top: 30px;
                    text-align: right;
                }
                .paper .bottom-data .payment-title {
                    display: block;
                    margin-bottom: 15px;
                }
            `,
            customerTaxId: '',
            orderList: [],
            totalPrice: 0,
            turnPartPrice: 0,
            discount: 0,
            taxPrice: 0,
            finalPrice: 0,
            appHelper: Helper
        }
    },
    props: {
        fields: Object,
        globalStyle: String
    },
    watch: {
        fields(value) {
            this.content = value;

            this.getTaxId();
            this.getOrderData();
            this.getTotalPrice();
            this.getTurnPrice();
            this.getDiscountData();
            this.getBottomPrice();
        }
    },
    mounted() {
        this.setupPaperStyle();
    },
    methods: {
        setupPaperStyle() {
            this.paperStyle = [ '<style>', this.globalStyle, this.localStyle, '</style>' ].join('');
        },
        getCustomerName() {
            let customerName = '';

            if (this.content.data.jobType === this.$Constants.JOB_FORM_STORE) {
                customerName = [ 'ชื่อร้านค้า', this.content.data.customerStore.name ].join(' ');
            } else if (this.content.data.jobType === this.$Constants.JOB_FORM_FLEET) {
                customerName = ['ชื่อบริษัท ', this.content.data.fleet.company ].join(' ');
            } else {
                customerName = ['ชื่อลูกค้า ', this.content.data.customer.customerFirstName, this.content.data.customer.customerLastName ].join(' ');
            }

            return customerName;
        },
        getAddress() {
            let address = '';

            switch (this.content.data.jobType) {
                case this.$Constants.JOB_FORM_STORE:
                    address = [ this.content.data.customerStore.address,
                                this.content.data.customerStore.subDistrict,
                                this.content.data.customerStore.district,
                                this.content.data.customerStore.province,
                                this.content.data.customerStore.postCode ].join(' ');
                    break;

                case this.$Constants.JOB_FORM_FLEET:
                    address = this.content.data.fleet.address;
                    break;
            }

            return address;
        },
        getTaxId() {
            this.customerTaxId = '';

            switch (this.content.data.jobType) {
                case this.$Constants.JOB_FORM_STORE:
                    this.customerTaxId = this.content.data.customerStore.taxId;
                    break;

                case this.$Constants.JOB_FORM_FLEET:
                    this.customerTaxId = this.content.data.fleet.taxId;
                    break;

                default:
                    this.customerTaxId = this.content.data.tax.taxId;
                    break;
            }
        },
        getTelData() {
            if (this.content.data.jobType === this.$Constants.JOB_FORM_STORE) {
                return this.content.data.customerStore.contactTel;
            } else if (this.content.data.jobType === this.$Constants.JOB_FORM_FLEET) {
                return this.content.data.fleet.contactTel;
            } else {
                return this.content.data.customer.customerTel;
            }
        },
        getCarData() {
            return [ this.content.data.customer.carBrand, this.content.data.customer.carModel, this.content.data.customer.carYearSerie ].filter(Boolean).join(' ');
        },
        getLicensePlateData() {
            return [ this.content.data.customer.licensePlate, ' (' + OptionLicensePlateProvince.service.getValueByKey(this.content.data.customer.licensePlateProvince) + ')'].join(' ');
        },
        getOrderData() {
            this.orderList = [];

            for (const item of this.content.data.order.productList) {
                const orderIndex = this.orderList.findIndex(x => x.inventoryKey === item.inventoryKey && x.dot === item.input.dot && x.price === parseFloat(item.input.price));

                if (orderIndex > -1) {
                    this.orderList[orderIndex].quantity += item.input.quantity;
                } else {
                    this.orderList.push({
                        sku: item.inventoryData.sku,
                        name: item.productData.name,
                        dot: item.input.dot,
                        price: parseFloat(item.input.price),
                        quantity: item.input.quantity
                    });
                }
            }

            for (const item of this.content.data.order.serviceList) {
                this.orderList.push({
                    sku: '',
                    name: item.topic,
                    dot: '',
                    price: parseFloat(item.price),
                    quantity: 1
                });
            }
        },
        getTotalPrice() {
            this.totalPrice = 0;

            for (const item of this.orderList) {
                this.totalPrice += (item.price * item.quantity);
            }
        },
        getDiscountData() {
            this.discountPrice = 0;

            this.content.data.order.discountList.forEach((item) => {
                this.discountPrice += parseFloat(item.discount);
            });
        },
        getTurnPrice() {
            this.turnPartPrice = 0;

            this.content.data.turnPartList.forEach((item) => {
                this.turnPartPrice += parseFloat(item.price);
            });
        },
        getBottomPrice() {
            const paidPrice = this.totalPrice - this.discountPrice - this.turnPartPrice;
            this.taxPrice = paidPrice * (this.content.data.bill.includeTax ? 0.07 : 0);
            this.finalPrice = paidPrice + this.taxPrice;
        },
        getOrderColumnHeight(index) {
            let maxHeight = 200;

            this.orderList.forEach(() => {
                maxHeight -= 30;
            });

            if (index === this.orderList.length - 1) {
                return { height: maxHeight + 'px' };
            }

            return '';
        }
    }
}
</script>